<template>
  <c-tick-flash :value="params.value">
    <span v-if="accessibilityFeatures" class="sr-only">{{ mloAriaText }}</span>
    <span v-if="!isSROnly">{{ params.valueFormatted }}</span>
    <span v-if="isSROnly" class="sr-only">{{ params.valueFormatted }}</span>
  </c-tick-flash>
</template>

<script>
import CTickFlash from '@custom/CTickFlash';
import { getAriaText } from '@utils/helpers';

export default {
  name: 'tick-flash-renderer',
  components: {
    CTickFlash
  },
  methods: {
    getAriaText,
    refresh(params) {
      if (params.value !== this.params.value) {
        this.params = params;
      }
      return true;
    }
  },
  computed: {
    accessibilityFeatures() {
      return this.$store.state.applicationSettings.accessibility.settings.accessibilityFeatures;
    },
    mloAriaText() {
      if (this.isSROnly) {
        return this.params.data.allTickerArray.join(', ');
      }
      return this.getAriaText(this.params);
    },
    isSROnly() {
      if (
        !this.params.node.group &&
        this.params.colDef.field === 'q._TRDPRC_1' &&
        this.params.data.index > 0 &&
        this.params.data.strategy === 'MLO'
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-tick-flash {
  &:hover {
    color: $white;
  }
}
</style>
